import { useEffect, useState } from 'react'
import { api } from '../../shared/api/http'
import type { Client, Company } from '../monitoring/monitoringApi'
import { ClientModuleAccessDialog, type ModuleAccessUser } from '../companies/ClientModuleAccessDialog'

export function UserModuleAccessAction({ user }: { user: { id: string; fullName: string; email: string } }) {
  const [open, setOpen] = useState(false), [companies, setCompanies] = useState<Company[]>([])
  const [companyId, setCompanyId] = useState(''), [clients, setClients] = useState<Client[]>([])
  const [selected, setSelected] = useState<Client | null>(null), [linked, setLinked] = useState<ModuleAccessUser[]>([])
  const [busy, setBusy] = useState(false), [error, setError] = useState(''), [editing, setEditing] = useState(false)
  useEffect(() => {
    if (!open) return
    let active = true
    setBusy(true); setError('')
    void api<Company[]>('/companies').then(items => { if (active) setCompanies(items) })
      .catch(() => { if (active) setError('Não foi possível carregar as empresas.') })
      .finally(() => { if (active) setBusy(false) })
    return () => { active = false }
  }, [open])
  useEffect(() => {
    setClients([]); setSelected(null); setEditing(false)
    if (!companyId || !open) return
    let active = true
    setBusy(true); setError('')
    void api<Client[]>(`/companies/${companyId}/clients`).then(items => { if (active) setClients(items.filter(item => !item.disabled)) })
      .catch(() => { if (active) setError('Não foi possível carregar os clientes.') })
      .finally(() => { if (active) setBusy(false) })
    return () => { active = false }
  }, [companyId, open])
  async function edit(client: Client) {
    setBusy(true); setError('')
    try {
      const items = await api<ModuleAccessUser[]>(`/companies/${companyId}/clients/${client.id}/users`)
      setLinked(items); setSelected(client); setEditing(true)
    } catch { setError('Não foi possível consultar os acessos.') } finally { setBusy(false) }
  }
  return <>
    <button onClick={() => { setOpen(true); setCompanyId(''); setError('') }}>Acessos por módulo</button>
    {open && !editing && <div className="media-modal client-editor-modal"><section className="entity-dialog" role="dialog" aria-modal="true" aria-labelledby="admin-module-picker">
      <h2 id="admin-module-picker">Acessos de {user.fullName}</h2>
      <p>Escolha a empresa e o cliente/local.</p>
      {error && <p role="alert">{error}</p>}
      <label>Empresa<select disabled={busy} value={companyId} onChange={event => setCompanyId(event.target.value)}><option value="">Selecione</option>{companies.map(company => <option key={company.id} value={company.id}>{company.tradeName}</option>)}</select></label>
      <div className="selection-list">{clients.map(client => <button disabled={busy} key={client.id} onClick={() => void edit(client)}>{client.name}<b>Editar acessos</b></button>)}</div>
      <div className="dialog-actions"><button disabled={busy} onClick={() => setOpen(false)}>Fechar</button></div>
    </section></div>}
    {open && editing && selected && <>
      {error && <div role="alert" className="page-error">{error}</div>}
      <ClientModuleAccessDialog client={selected} users={[{ ...user, role: 'client' }]} initialUser={{ ...user, role: 'client' }} linked={linked} busy={busy} onClose={() => setEditing(false)} onSave={body => {
        setBusy(true); setError('')
        void api(`/companies/${companyId}/clients/${selected.id}/users`, { method: 'PUT', body: JSON.stringify(body) })
          .then(() => { setEditing(false); setOpen(false) }).catch(() => setError('Não foi possível salvar os acessos. Apenas o administrador geral pode alterar perfis.'))
          .finally(() => setBusy(false))
      }} />
    </>}
  </>
}
